// import { getCookies } from '@/utils/cookies'
import Api from './API'
// import {getCookies} from '@/utils/cookies'

// const crypto = require('crypto')
function NowakModal () {
  if (!(this instanceof NowakModal)) {
    return new NowakModal()
  }
}
// var authToken = localStorage.getItem('authToken')
// console.log(authToken, 'authToken')
// ++++++++++++++++++++++++++++ user login and user data api call start ++++++++++++++++++++++++++++
/*
* staff login api
*/
// NowakModal.prototype.loginUser = async function (
//   email,
//   password,
//   crmId,
//   rememberMe,
//   callBackFunc,
//   onError
// ) {
//   var keyStr = 'CrmGB!m3@p!'
//   const algorithm = 'aes-256-cfb'
//   const hash = crypto.createHash('sha256')
//   hash.update(keyStr)
//   const keyBytes = hash.digest()
//   const iv = crypto.randomBytes(16)
//   const cipher = crypto.createCipheriv(algorithm, keyBytes, iv)
//   const enc = [iv, cipher.update(password, 'utf8')]
//   enc.push(cipher.final())
//   password = Buffer.concat(enc).toString('base64')
//   const data = {
//     email: email,
//     password: password,
//     platform: 'web',
//     crmId: crmId
//   }
//   console.log(data)
//   Api.login(data).then(data => {
//     if (data.success === 1) {
//       callBackFunc(data)
//     } else {
//       onError(data)
//     }
//   })
// }
/* ***** *********** ************* **************** ******************* ****************** ****
*
*                                             ME material Api
*
***** *********** ************* **************** ******************* ****************** **** */
NowakModal.prototype.login = async function (
  loginUser,
  callBackFunc,
  onError
) {
  const data = JSON.stringify(loginUser)
  Api.login(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.EmployeeList = async function (
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('formData', JSON.stringify(formData))
  // console.log(formData, 'formData')
  Api.EmployeeList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.DepartmentList = async function (
  showInActive,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('showInActive', showInActive)
  Api.DepartmentList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.BranchList = async function (
  showInActive,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('showInActive', showInActive)
  Api.BranchList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.designationList = async function (
  showInActive,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('showInActive', showInActive)
  Api.designationList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.employeeTypeList = async function (
  showInActive,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('showInActive', showInActive)
  Api.employeeTypeList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.AddleaveReason = async function (
  leaveReasonObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('leaveReasonObj', JSON.stringify(leaveReasonObj))
  Api.AddleaveReason(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetLeaveReasonList = async function (
  showInActive,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('showInActive', showInActive)
  Api.GetLeaveReasonList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.UpdateLeaveReasonOrder = async function (
  leaveResonOrder,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('leaveResonOrder', JSON.stringify(leaveResonOrder))
  Api.UpdateLeaveReasonOrder(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// ********Leave Status List**************
NowakModal.prototype.GetLeaveStatusList = async function (
  showInActive,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('showInActive', showInActive)
  Api.GetLeaveStatusList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.UpdateLeaveStatusOrder = async function (
  leavestatusOrder,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('leavestatusOrder', JSON.stringify(leavestatusOrder))
  Api.UpdateLeaveStatusOrder(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.UpdateLeaveStatusColor = async function (
  leavestatusObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('leavestatusObj', JSON.stringify(leavestatusObj))
  Api.UpdateLeaveStatusColor(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.DeviceListing = async function (
  showInActive,
  search,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('showInActive', showInActive)
  data.append('search', search)
  Api.DeviceListing(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.moduleList = async function (
  employeeId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('employeeId', employeeId)
  Api.moduleList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.GetEmployeeReportDetails = async function (
  empid,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empid', empid)
  Api.GetEmployeeReportDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.ReportTolist = async function (
  search,
  moduleSlug,
  branchId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('search', search)
  data.append('moduleSlug', moduleSlug)
  data.append('branchId', branchId)
  Api.ReportTolist(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.BranchDeptlist = async function (
  branchId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('branchId', branchId)
  Api.BranchDeptlist(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.shiftlist = async function (
  showInActive,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('showInActive', showInActive)
  Api.shiftlist(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.AddEmployee = async function (
  empObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empObj', JSON.stringify(empObj))
  Api.AddEmployee(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.RequiredDataForNewEmployee = async function (
  showInActive,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('showInActive', showInActive)
  Api.RequiredDataForNewEmployee(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.updateBranchOrder = async function (
  branchObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('branchObj', branchObj)
  Api.updateBranchOrder(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.updateDepartmentOrder = async function (
  departmentListOrder,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('departmentListOrder', departmentListOrder)
  Api.updateDepartmentOrder(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// Employee detail screen api start
NowakModal.prototype.EmaployeeBasicDetail = async function (
  employeeId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empid', employeeId)
  Api.EmaployeeBasicDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.EmaployeeBranchDetail = async function (
  employeeId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empid', employeeId)
  Api.EmaployeeBranchDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// bank DEtails

NowakModal.prototype.loadEmployeeBankDetail = async function (
  employeeId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', employeeId)
  Api.loadEmployeeBankDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// expeience detail

NowakModal.prototype.loadEmployeeExperienceDetail = async function (
  employeeId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empid', employeeId)
  Api.loadEmployeeExperienceDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// educational detail

NowakModal.prototype.loadEmpEducationalDetail = async function (
  employeeId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empid', employeeId)
  Api.loadEmpEducationalDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// salary detail

NowakModal.prototype.loadEmployeeSalaryDetail = async function (
  employeeId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', employeeId)
  Api.loadEmployeeSalaryDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// document details

NowakModal.prototype.loadDocumentDetails = async function (
  employeeId,
  // obj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', employeeId)
  // data.append('documentObj', JSON.stringify(obj))
  Api.loadDocumentDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// NowakModal.prototype.UploadDocToTemp  = async function (
//   file,
//   callBackFunc,
//   onError
// ) {
//   const data = new FormData()
//   data.append('authToken', localStorage.getItem('authToken'))
//   data.append('file', file)
//   Api.UploadDocToTemp (data).then(data => {
//     if (data.success === 1) {
//       callBackFunc(data)
//     } else {
//       onError(data)
//     }
//   })
// }

NowakModal.prototype.AddDocumentDetails = async function (
  employeeId,
  documentArray,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', employeeId)
  data.append('documentArray', JSON.stringify(documentArray))
  Api.AddDocumentDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// -------------------------------update emp details-----------------------------------------
// upadate basic details

// update personal details

NowakModal.prototype.savePersonalDetails = async function (
  empId,
  employeeObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  data.append('employeeObj', JSON.stringify(employeeObj))
  Api.savePersonalDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// ALL Shift List
NowakModal.prototype.OpenShiftList = async function (
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('formData', JSON.stringify(formData))
  Api.OpenShiftList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetAllShiftList = async function (
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('formData', formData)
  Api.GetAllShiftList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.BranchDetails = async function (
  branchId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('branchId', branchId)
  Api.BranchDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.DepartmentDetails = async function (
  departmentId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('departmentId', departmentId)
  Api.DepartmentDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.DeviceDetails = async function (
  deviceId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('deviceId', deviceId)
  Api.DeviceDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.VerifyContactNumber = async function (
  contactNo,
  empId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('contactNo', contactNo)
  data.append('empId', empId)
  Api.VerifyContactNumber(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.EmployeeCodeVerification = async function (
  employeeCode,
  empId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('employeeCode', employeeCode)
  data.append('empId', empId)
  Api.EmployeeCodeVerification(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.EmployeeEmailVerification = async function (
  email,
  empId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('email', email)
  data.append('empId', empId)
  // console.log(data, 'data')
  Api.EmployeeEmailVerification(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.EmployeeLoginCodeVerification = async function (
  timeclocklogincode,
  empId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('timeclocklogincode', timeclocklogincode)
  data.append('empId', empId)
  Api.EmployeeLoginCodeVerification(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.getBreakList = async function (
  isAllBreak,
  isStandard,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('isAllBreak', isAllBreak)
  data.append('isStandard', isStandard)
  Api.getBreakList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.getSettingBreakList = async function (
  isActive,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('isActive', isActive)
  Api.getSettingBreakList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.updateBreakOrder = async function (
  breakList,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('breakList', breakList)
  Api.updateBreakOrder(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.addEditBreak = async function (
  breakObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('breakObj', breakObj)
  Api.addEditBreak(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.ShiftDetails = async function (
  timesheetId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('timesheetId', timesheetId)
  Api.ShiftDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.Notesdetails = async function (
  timesheetId,
  limit,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('timeSheetId', timesheetId)
  console.log(limit)
  Api.Notesdetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.UploadDocToTemp = async function (
  file,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('file', file)
  Api.UploadDocToTemp(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.DownloadDocs = async function (
  file,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('file', file)
  Api.DownloadDocs(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.AddBranch = async function (
  branchObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('branchObj', JSON.stringify(branchObj))
  Api.AddBranch(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.AddDepartment = async function (
  departmentObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('departmentObj', JSON.stringify(departmentObj))
  Api.AddDepartment(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.AddDevice = async function (
  deviceObj,
  notificationId,
  empId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('deviceObj', JSON.stringify(deviceObj))
  data.append('notificationId', notificationId)
  data.append('empId', empId)
  Api.AddDevice(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.AddDesignation = async function (
  designationObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('designationObj', JSON.stringify(designationObj))
  Api.AddDesignation(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.UpdateDesignationOrder = async function (
  designationListOrder,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('designationListOrder', JSON.stringify(designationListOrder))
  Api.UpdateDesignationOrder(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.AddemployeeType = async function (
  employeeTypeObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('employeeTypeObj', JSON.stringify(employeeTypeObj))
  Api.AddemployeeType(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.UpdateEmployeeTypeOrder = async function (
  empTypeListOrder,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empTypeListOrder', JSON.stringify(empTypeListOrder))
  Api.UpdateEmployeeTypeOrder(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.saveEmployeeBasicDetail = async function (
  empId,
  employeeObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  data.append('employeeObj', JSON.stringify(employeeObj))
  Api.saveEmployeeBasicDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.saveEmergencyDetails = async function (
  empId,
  emergencyDetails,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  data.append('emergencyDetails', JSON.stringify(emergencyDetails))
  Api.saveEmergencyDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.saveAditionalDetails = async function (
  empId,
  employeeObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  data.append('employeeObj', JSON.stringify(employeeObj))
  Api.saveAditionalDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.saveBranchDetails = async function (
  empId,
  branchObj,
  reportObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  data.append('branchObj', JSON.stringify(branchObj))
  data.append('reportObj', JSON.stringify(reportObj))
  Api.saveBranchDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.saveSalaryDetails = async function (
  empId,
  salaryObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  data.append('salaryObj', JSON.stringify(salaryObj))
  Api.saveSalaryDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.saveBankDetails = async function (
  empId,
  bankObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  data.append('bankObj', JSON.stringify(bankObj))
  Api.saveBankDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.saveEducationDetails = async function (
  empId,
  educObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  data.append('educObj', JSON.stringify(educObj))
  Api.saveEducationDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.saveExperienceDetails = async function (
  empId,
  workObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  data.append('workObj', JSON.stringify(workObj))
  Api.saveExperienceDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// login detial

NowakModal.prototype.loadLoginDetails = async function (
  empId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  Api.loadLoginDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.UpdateProfile = async function (
  employeeId,
  file,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('employeeId', employeeId)
  data.append('file', file)
  Api.UpdateProfile(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// save login details

NowakModal.prototype.saveLoginDetail = async function (
  empId,
  loginObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  data.append('loginObj', JSON.stringify(loginObj))
  Api.saveLoginDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.ADDShift = async function (
  shiftObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('shiftObj', JSON.stringify(shiftObj))
  Api.ADDShift(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.UpdateShiftOrder = async function (
  shiftList,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('shiftList', shiftList)
  Api.UpdateShiftOrder(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.ADDNote = async function (
  newNoteDetail,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('newNoteDetail', JSON.stringify(newNoteDetail))
  Api.ADDNote(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.LoadEmpDeviceDetails = async function (
  empId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  Api.LoadEmpDeviceDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.updateDeviceDetails = async function (
  // employeeId,
  deviceObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  // data.append('employeeId', employeeId)
  data.append('deviceObj', JSON.stringify(deviceObj))
  Api.updateDeviceDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// delete document

NowakModal.prototype.deleteDocument = async function (
  deleteObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('deleteObj', JSON.stringify(deleteObj))
  Api.deleteDocument(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// delete document from tempt

NowakModal.prototype.deleteDocumentFromTemp = async function (
  deleteFileObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('deleteFileObj', JSON.stringify(deleteFileObj))
  Api.deleteDocumentFromTemp(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.DeleteMultipleFileFromTemp = async function (
  deleteFileObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('deleteFileObj', JSON.stringify(deleteFileObj))
  Api.DeleteMultipleFileFromTemp(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// downloadFile
NowakModal.prototype.downloadFile = async function (
  filevaultid,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('filevaultid', filevaultid)
  Api.downloadFile(data).then(data => {
    if (data) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.downloadNoteAttachments = async function (
  noteId,
  filevaultid,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('noteId', noteId)
  data.append('filevaultid', filevaultid)
  Api.downloadNoteAttachments(data).then(data => {
    if (data) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.getLocation = async function (
  noteId,
  filevaultid,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('noteId', noteId)
  data.append('filevaultid', filevaultid)
  Api.getLocation(data).then(data => {
    if (data) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetTimesheetLocation = async function (
  timesheetId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('timeSheetId', timesheetId)
  Api.GetTimesheetLocation(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// Get ALl shift list
NowakModal.prototype.GetAllShiftList = async function (
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('formData', formData)
  Api.GetAllShiftList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// Get Open shift list
NowakModal.prototype.GetOpenShiftList = async function (
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('formData', formData)
  Api.GetOpenShiftList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetCompletedShiftList = async function (
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('formData', JSON.stringify(formData))
  Api.GetCompletedShiftList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetEmployeeNotClockedInYet = async function (
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('formData', JSON.stringify(formData))
  Api.GetEmployeeNotClockedInYet(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetFilterRelatedAllData = async function (
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  Api.GetFilterRelatedAllData(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.SearchForMoreDataOfEmployee = async function (
  moduleSlug,
  search,
  branchId,
  limit,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('moduleSlug', moduleSlug)
  data.append('search', search)
  data.append('branchId', branchId)
  data.append('limit', limit)
  Api.SearchForMoreDataOfEmployee(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// ******************Missing Shift*****************

NowakModal.prototype.CheckForOverLapTimesheet = async function (
  missingShiftObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('missingShiftObj', JSON.stringify(missingShiftObj))
  Api.CheckForOverLapTimesheet(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.AddMissingShift = async function (
  missingShiftObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('missingTimeObj', JSON.stringify(missingShiftObj))
  Api.AddMissingShift(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetShiftDetailsOfEmployee = async function (
  empId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empid', empId)
  Api.GetShiftDetailsOfEmployee(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

//* **************LEAVE APIS START HERE ********/
NowakModal.prototype.GetLeaveList = async function (
  formData,
  showMyLeave,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('formData', formData)
  data.append('showMyLeave', showMyLeave)
  Api.GetLeaveList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetLeaveDetails = async function (
  leaveId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('leaveId', leaveId)
  Api.GetLeaveDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.AddNewLeave = async function (
  leaveObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('leaveObj', JSON.stringify(leaveObj))
  Api.AddNewLeave(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.UpdateEmployeeLeaveStatus = async function (
  leaveObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('leaveObj', JSON.stringify(leaveObj))
  Api.UpdateEmployeeLeaveStatus(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.CheckForLeaveOverlap = async function (
  leaveObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('leaveDetails', leaveObj)
  Api.CheckForLeaveOverlap(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// ******Update Timesheet************/
NowakModal.prototype.UpdateTimesheet = async function (
  timeObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('timeObj', JSON.stringify(timeObj))
  Api.UpdateTimesheet(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.UpdateTimesheetBreakDetails = async function (
  timeObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('timeObj', timeObj)
  Api.UpdateTimesheetBreakDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.CheckTimesheetOverlap = async function (
  timeObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('timeObj', JSON.stringify(timeObj))
  Api.CheckTimesheetOverlap(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.CheckForBreakOverlap = async function (
  timeObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('timeObj', timeObj)
  Api.CheckForBreakOverlap(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetNotificationForDevice = async function (
  communicationTypeSlug,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('communicationTypeSlug', communicationTypeSlug)
  Api.GetNotificationForDevice(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.AcceptDeviceNotification = async function (
  deviceObj,
  notificationId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('deviceObj', JSON.stringify(deviceObj))
  data.append('notificationId', notificationId)
  Api.AcceptDeviceNotification(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetLogedInEmployeePermissions = async function (
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  Api.GetLogedInEmployeePermissions(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// GET PERMISSIONS
NowakModal.prototype.GetPermissionForMenuAndSubMenu = async function (
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))

  Api.GetPermissionForMenuAndSubMenu(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.AddNewCompanyRole = async function (
  roleDetails,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('roleDetails', JSON.stringify(roleDetails))
  Api.AddNewCompanyRole(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetCompanyRoleList = async function (
  sortByActive,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('sortByActive', sortByActive)
  Api.GetCompanyRoleList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.UpdateRoleOrder = async function (
  roleDetails,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('roleDetails', roleDetails)
  Api.UpdateRoleOrder(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetRoleDetails = async function (
  roleId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('roleId', roleId)
  Api.GetRoleDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetEmployeePermissions = async function (
  empId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('employeeId', empId)
  Api.GetEmployeePermissions(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.UpdateEmployeePermissions = async function (
  empId,
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('employeeId', empId)
  data.append('formData', JSON.stringify(formData))
  Api.UpdateEmployeePermissions(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetMaxAndMinBReakDates = async function (
  timesheetId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('timesheetId', timesheetId)
  Api.GetMaxAndMinBReakDates(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetTimesheetDetailsOfLoggedInEmployee = async function (
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  Api.GetTimesheetDetailsOfLoggedInEmployee(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetListOfBranchAndEmployeeInShift = async function (
  shiftId,
  getTotalShift,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('shiftId', shiftId)
  data.append('getTotalShift', getTotalShift)
  Api.GetListOfBranchAndEmployeeInShift(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// ***********************HOLIDAY API Start HERE******************************//
NowakModal.prototype.GetHolidayList = async function (
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  Api.GetHolidayList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// Get Holiday Details List
NowakModal.prototype.GetHolidayDetailsList = async function (
  holidayListId,
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('holidayListId', holidayListId)
  data.append('formData', formData)
  Api.GetHolidayDetailsList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// Add new Holiday List
NowakModal.prototype.AddNewHolidayList = async function (
  holidayObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('holidayObj', holidayObj)
  Api.AddNewHolidayList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// Add new Holiday
NowakModal.prototype.AddNewHoliday = async function (
  holidayObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('holidayObj', holidayObj)
  Api.AddNewHoliday(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// Update Holiday
NowakModal.prototype.UpdateHolidayDetails = async function (
  holidayDetailObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('holidayDetailObj', holidayDetailObj)
  Api.UpdateHolidayDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// Update holiday list details
NowakModal.prototype.UpdateHolidayListDetails = async function (
  holidayObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('holidayObj', holidayObj)
  Api.UpdateHolidayListDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// DELETE HOLIDAY DETAILS
NowakModal.prototype.DeleteHolidayDetails = async function (
  holidayDetailId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('holidayDetailId', holidayDetailId)
  Api.DeleteHolidayDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.CheckForHolidayOverlap = async function (
  title,
  holidayDetailID,
  holidayListID,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('title', title)
  data.append('holidayDetailID', holidayDetailID)
  data.append('holidayListID', holidayListID)
  Api.CheckForHolidayOverlap(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.CheckForHolidayListOverlap = async function (
  title,
  holidayListID,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('title', title)
  data.append('holidayListID', holidayListID)
  Api.CheckForHolidayListOverlap(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetMaxAndMixHolidays = async function (
  holidayListID,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('holidayListID', holidayListID)
  Api.GetMaxAndMixHolidays(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// HOLIDAY CATEGORY API's
NowakModal.prototype.GetCategoryList = async function (
  sortByActive,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('sortByActive', sortByActive)
  Api.GetCategoryList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.AddCategory = async function (
  categoryDetail,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('categoryObj', categoryDetail)
  Api.AddCategory(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.UpdateCategoryOrder = async function (
  categoryList,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('categoryListOrder', categoryList)
  Api.UpdateCategoryOrder(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.ChangeEmployeeAndBranchShiftId = async function (
  shiftDetails,
  shiftId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('shiftDetails', JSON.stringify(shiftDetails))
  data.append('shiftId', shiftId)
  Api.ChangeEmployeeAndBranchShiftId(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.CheckForShiftStartAndEndTimeoverlap = async function (
  startTime,
  endTime,
  shiftId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('startTime', startTime)
  data.append('endTime', endTime)
  data.append('shiftId', shiftId)

  Api.CheckForShiftStartAndEndTimeoverlap(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.AddNewHolidays = async function (
  holidayObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('holidayObj', JSON.stringify(holidayObj))
  Api.AddNewHolidays(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetBranchRelatedDeptAndEmp = async function (
  branchId,
  getTotalOfData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('branchId', branchId)
  data.append('getTotalOfData', getTotalOfData)

  Api.GetBranchRelatedDeptAndEmp(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetBranchAndDepartmentList = async function (
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))

  Api.GetBranchAndDepartmentList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.UpdateBranchDepartmentDetails = async function (
  branchObj,
  branchId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('branchObj', JSON.stringify(branchObj))
  data.append('branchId', branchId)
  Api.UpdateBranchDepartmentDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetDepartmentRelatedData = async function (
  departmentId,
  getTotalOfData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('departmentId', departmentId)
  data.append('getTotalOfData', getTotalOfData)
  Api.GetDepartmentRelatedData(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.ChangeDepartmentRelatedData = async function (
  departmentDetails,
  departmentId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('departmentDetails', JSON.stringify(departmentDetails))
  data.append('departmentId', departmentId)
  Api.ChangeDepartmentRelatedData(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetEmployeeListForSelectedModule = async function (
  moduleSlug,
  search,
  limit,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('moduleSlug', moduleSlug)
  data.append('search', search)
  data.append('limit', limit)

  Api.GetEmployeeListForSelectedModule(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetActivityLogForGivenModule = async function (
  moduleSlug,
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('moduleSlug', moduleSlug)
  data.append('formData', JSON.stringify(formData))
  Api.GetActivityLogForGivenModule(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetRequiredDataForActivityLog = async function (
  moduleSlug,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('moduleSlug', moduleSlug)

  Api.GetRequiredDataForActivityLog(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
/** ****************************NOTES*****************************/
NowakModal.prototype.AddNewNotes = async function (
  permissionSlug,
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('permissionSlug', permissionSlug)
  data.append('formData', JSON.stringify(formData))
  Api.AddNewNotes(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetNotesDetails = async function (
  permissionSlug,
  noteId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('permissionSlug', permissionSlug)
  data.append('noteId', noteId)
  Api.GetNotesDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.AddDeviceFromLogin = async function (
  deviceObj,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('deviceObj', JSON.stringify(deviceObj))
  Api.AddDeviceFromLogin(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.DownloadNotes = async function (
  noteId,
  filevaultId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('noteId', noteId)
  data.append('filevaultId', filevaultId)

  Api.DownloadNotes(data).then(data => {
    if (data) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.ApproveDevice = async function (
  deviceObj,
  notificationId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('deviceObj', JSON.stringify(deviceObj))
  data.append('notificationId', notificationId)
  Api.ApproveDevice(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.CheckForDeviceOverlap = async function (
  checkType,
  deviceName,
  macAddress,
  deviceId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('checkType', checkType)
  data.append('deviceName', deviceName)
  data.append('macAddress', macAddress)
  data.append('deviceId', deviceId)
  Api.CheckForDeviceOverlap(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetActivityLogDetail = async function (
  formData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('formData', JSON.stringify(formData))
  Api.GetActivityLogDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
NowakModal.prototype.GetModuleListForEmployee = async function (
  empId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  data.append('empId', empId)
  Api.GetModuleListForEmployee(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.upcomingHolidayListForDashboard = async function (
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  Api.upcomingHolidayListForDashboard(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.getTodayLeavelist = async function (
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  Api.getTodayLeavelist(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

NowakModal.prototype.getUpcomingLeaveList = async function (
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', localStorage.getItem('authToken'))
  Api.getUpcomingLeaveList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

export default NowakModal



// WEBPACK FOOTER //
// ./src/api/NowakModel.js